import { isFunction } from '@antv/util';
import { CommonEvent } from '../constants';
import { isCollapsed } from '../utils/collapsibility';
import { isElement } from '../utils/element';
import { BaseBehavior } from './base-behavior';
/**
 * <zh/> 展开/收起组合元素交互
 *
 * <en/> Collapse/Expand Combo behavior
 * @remarks
 * <zh/> 通过双击 Combo 进行展开或收起 Combo。
 *
 * <en/> Expand or collapse a Combo by double-clicking on it.
 */
export class CollapseExpand extends BaseBehavior {
    static defaultOptions = {
        enable: true,
        animation: true,
        trigger: CommonEvent.DBLCLICK,
    };
    constructor(context, options) {
        super(context, Object.assign({}, CollapseExpand.defaultOptions, options));
        this.bindEvents();
    }
    update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        const { graph } = this.context;
        const { trigger } = this.options;
        graph.on(`node:${trigger}`, this.onCollapseExpand);
        graph.on(`combo:${trigger}`, this.onCollapseExpand);
    }
    unbindEvents() {
        const { graph } = this.context;
        const { trigger } = this.options;
        graph.off(`node:${trigger}`, this.onCollapseExpand);
        graph.off(`combo:${trigger}`, this.onCollapseExpand);
    }
    onCollapseExpand = async (event) => {
        if (!this.validate(event))
            return;
        const { target } = event;
        if (!isElement(target))
            return;
        const id = target.id;
        const { model, graph } = this.context;
        const data = model.getElementDataById(id);
        if (!data)
            return false;
        const { onCollapse, onExpand, animation } = this.options;
        if (isCollapsed(data)) {
            await graph.expandElement(id, animation);
            onExpand?.(id);
        }
        else {
            await graph.collapseElement(id, animation);
            onCollapse?.(id);
        }
    };
    validate(event) {
        if (this.destroyed)
            return false;
        const { enable } = this.options;
        if (isFunction(enable))
            return enable(event);
        return !!enable;
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
//# sourceMappingURL=collapse-expand.js.map